window.alpineLinkData = function()
{
    return {
        isFollowingMouse: false,
        nextTop: 16,
        nextLeft: 16,
        animation: null,
        resetPositions(){
            var rect = this.$refs.root.getBoundingClientRect();
            this.nextLeft = rect.width - 32;
            this.nextTop = (rect.height / 2) - 32;
        },
        updatePositions(event, element){
            this.nextTop = event.clientY - element.getBoundingClientRect().top;
            this.nextLeft = event.clientX - element.getBoundingClientRect().left;
        },
        animate(){
            if (this.animation){
                this.animation.pause();
            }
            // this.animation = this.$refs.circle.animate([
            //     transform: []
            // ], {
            //
            // }); WIP
            this.$refs.circle.style.transform = `translate(${this.nextLeft}px, ${this.nextTop}px)`;
        },
        move: window.throttle(function($event, $el)
        {
            this.isFollowingMouse == true ? ( this.updatePositions($event, $el), this.animate() ) : 0;
        }, 200),
    };
};
